import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=121b5850&"
import script from "./Article.vue?vue&type=script&lang=js&"
export * from "./Article.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npm.taobao.org+vue-loader@15.9.6_0ddcf7a5036583246c8e31814ee464af/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports